import React from 'react';

const Context = React.createContext();
const { Provider, Consumer } = Context;

export { Context, Provider, Consumer };